// Design tokens — single source of truth. Resolves to CSS variables defined
// in index.css; values flip when <html> gets the `.dark` class. Use either
// `COLORS.x` here for inline styles, or the equivalent Tailwind class name
// (bg-bg-panel, text-ink, etc.).
export const COLORS = {
    bg: 'var(--bg)',
    bgInput: 'var(--bg-input)',
    bgPanel: 'var(--surface-1)',
    bgCard: 'var(--surface-2)',
    bgHover: 'var(--surface-hover)',
    bgActive: 'var(--surface-active)',
    border: 'var(--border)',
    borderHover: 'var(--border-strong)',
    ink: 'var(--ink)',
    muted: 'var(--muted)',
    ghost: 'var(--ghost)',
    accent: 'var(--accent)',
    accentBg: 'var(--accent-bg)',
    accentBorder: 'var(--accent-border)',
    onAccent: 'var(--on-accent)',
    warn: 'var(--warn)',
    warnBg: 'var(--warn-bg)',
    warnBorder: 'var(--warn-border)',
    err: 'var(--err)',
    errBg: 'var(--err-bg)',
    errBorder: 'var(--err-border)',
    get: 'var(--m-get)',
    post: 'var(--m-post)',
    patch: 'var(--m-patch)',
    delete: 'var(--m-delete)',
} as const;

export type Method = 'GET' | 'POST' | 'PATCH' | 'PUT' | 'DELETE';

export function methodColor(m: Method): string {
    switch (m) {
        case 'GET': return COLORS.get;
        case 'POST': return COLORS.post;
        case 'PATCH':
        case 'PUT': return COLORS.patch;
        case 'DELETE': return COLORS.delete;
    }
}
